<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>钻头列表</el-breadcrumb-item>
      <el-breadcrumb-item>复合片记录</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="钻头详情">
      </el-page-header>
      <div class="panel-heading">
        <div class="panel-title pl-0">
          钻头序列号：<DrillLink :no="drill.serial_number"></DrillLink>
        </div>
      </div>
      <div>
        <el-table :data="drill.pdc_records">
          <el-table-column label="时间" prop="option_time"></el-table-column>
          <el-table-column label="钻头序列号">
            <template slot-scope="scope">
              <div v-for="no in scope.row.numbers" :key="no">
                <DrillLink :no="no"></DrillLink>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="编码" prop="code"></el-table-column>
          <el-table-column label="规格" prop="specification"></el-table-column>
          <el-table-column label="倒角" prop="model_number"></el-table-column>
          <el-table-column label="齿形" prop="tooth_type"></el-table-column>
          <el-table-column label="尺寸" prop="size"></el-table-column>
          <el-table-column label="数量" prop="number"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { drillDetail } from '../../../service/getData'
export default {
  data() {
    return {
      drill: {},
    }
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    async getData(id) {
      let res = await drillDetail(id)
      res.data.pdc_records = res.data.pdc_records.map((pdc) => {
        let arr = pdc.drill_serial_numbers.split(',')
        let query = res.data.serial_number.substring(
          0,
          res.data.serial_number.length - 1
        )
        var numbers = []
        for (var j = 0; j < arr.length; j++) {
          let number = arr[j].substring(0, arr[j].length - 1)
          if (number == query) {
            numbers.push(arr[j])
          }
        }
        pdc.numbers = numbers
        pdc.number = Math.round(pdc.number / arr.length)
        if (pdc.number == 0) {
          pdc.number = 1
        }
        return pdc
      })

      this.drill = res.data
    },
  },
}
</script>